import React, { useEffect, useState } from 'react';
import redLightGif from '../assets/images/giphy.webp'; 
// Aciliyet hücresi
export function UrgencyCell({ urgency }) {
  if (urgency === "Yüksek") {
    return (
      <SoftBlinkingRedLightGif
        size={24}
        blinkSpeed={500}
        gifUrl={redLightGif}
      />
    );
  }

  // Diğer aciliyet seviyeleri için normal etiket
  let bgColor = "";
  switch (urgency) {
   
  }

  return (
    <span className={`${bgColor} text-white px-3 py-0 rounded-full text-sm font-semibold`}>
      {urgency}
    </span>
  );
}

// GIF ile yanıp sönen acil durum ışığı
export default function SoftBlinkingRedLightGif({ size = 64, className = '', style = {}, blinkSpeed = 500, gifUrl }) {
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    if (!blinkSpeed) return;
    const interval = setInterval(() => {
      setOpacity(prev => (prev === 1 ? 0.5 : 1));
    }, blinkSpeed);
    return () => clearInterval(interval);
  }, [blinkSpeed]);

  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-block',
        width: size,
        height: size,
        opacity,
        transition: 'opacity 0.3s',
        ...style
      }}
      className={className}
    >
      <img
        src={gifUrl}
        alt="Acil durum lambası"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        }}
      />
    </div>
  );
}
